<form [formGroup]="form" autocomplete="off" class="form-horizontal">

  <div class="form-row">
    <label class="col-sm-4 col-form-label"
           for="bundesland{{index}}">{{ 'COMMON_UI.FINANZAMT.BUNDESLAND.LABEL' | translate }}</label>
    <div class="col-sm-8">
      <select (change)="this.form.get('finanzamtnummer').setValue(null)" class="form-control" datevMessagePath="bundesland{{objectId}}"
              formControlName="bundesland" id="bundesland{{index}}" utilsCheckValidity
              utilsControlState
              utilsMarkRequired
              utilsValidationMessage>
        <option [ngValue]="null" hidden
                selected>{{ 'COMMON_UI.FINANZAMT.BUNDESLAND.NULL' | translate }}</option>
        <option *ngFor="let value of enumKeys(bundeslandEnum)"
                [ngValue]="bundeslandEnum[value]">
          {{ 'COMMON_UI.FINANZAMT.BUNDESLAND.NUMBER_' + bundeslandEnum[value] | translate }}
        </option>
      </select>
    </div>
  </div>

  <div *ngIf="form?.get('bundesland').value" class="form-row">
    <label class="col-sm-4 col-form-label"
           for="finanzamtnummer{{index}}">{{ 'COMMON_UI.FINANZAMT.FINANZAMTNUMMER.LABEL' | translate }}</label>
    <div class="col-sm-8">
      <select class="form-control" datevMessagePath="finanzamtnummer{{objectId}}" formControlName="finanzamtnummer"
              id="finanzamtnummer{{index}}" utilsCheckValidity utilsControlState
              utilsMarkRequired
              utilsValidationMessage>
        <option [ngValue]="null" hidden
                selected>{{ 'COMMON_UI.FINANZAMT.FINANZAMTNUMMER.NULL' | translate }}</option>
        <option *ngFor="let finanzamt of filteredFinanzamtMap | keyvalue: sortByValue"
                [ngValue]="finanzamt.key">
          {{ finanzamt.value }}
        </option>
      </select>
    </div>
  </div>

</form>
